import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAdminAuth } from './context/AdminAuthContext';

/**
 * Admin App - Independent Route Protection
 * No dependencies on other apps
 */
export default function AdminProtectedRoute({ children }) {
  const location = useLocation();
  const { isLoading, hasAdminAccess } = useAdminAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-muted/20">
        <p className="text-sm text-muted-foreground">Checking admin permissions…</p>
      </div>
    );
  }

  if (!hasAdminAccess) {
    return <Navigate to="/admin/onboarding" state={{ from: location }} replace />;
  }

  return children;
}
